import styled from "styled-components"
import { Link } from "react-router-dom"
import { mobile, medScreen, smallScreen } from "../../Responsive"

export const Container = styled.div`
    margin-top: 20px;
    padding: 20px;
    font-size: var(--fontM);

    @media screen and (max-width: ${medScreen}) {
        font-size: var(--fontS);
        padding: 10px;
    }

    @media screen and (max-width: ${smallScreen}) {
        font-size: var(--fontXS);
        padding: 5px;
    }
`

export const IconWrapper = styled.div`
    width: 100%;
    height: 100%;
    border-radius: 20px;
    position: absolute;
    top: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    z-index: 3;
    opacity: 0;
    display: none;
    align-items: center;
    justify-content: center;
    transition: all 0.5s ease;
`

export const StyledLink = styled(Link)`
    display: flex;
    align-items: center;
    color: inherit;
`

export const MobileIcon = styled.div`
    display: none;
`

export const ProductDetail = styled.div`
    display: flex;

    @media (hover: hover) {
        &:hover ${IconWrapper} {
            display: flex;
            opacity: 1;
        }
    }

    @media (hover: none) {
        &:focus ${IconWrapper} {
            display: flex;
            opacity: 1;
        }

        &:focus ${MobileIcon} {
            display: flex;
        }

        &:focus ${StyledLink} {
            display: none;
        }
    }

    ${mobile({ flexDirection: "column" })}   
`

export const Image = styled.img`
    height: 100%;
    width: 100%;
    border-radius: 20px;
    object-fit: cover;
    z-index: 2;
`

export const Details = styled.div`
    width: 200px;
    padding: 20px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    font-size: var(--fontS);

    @media screen and (max-width: ${medScreen}) {
        font-size: var(--fontXS);
        padding: 10px;
    }

    @media screen and (max-width: ${smallScreen}) {
        font-size: var(--fontXS);
        padding: 5px;
    }
    
`

export const ProductInfo = styled.span`
`

export const ImageContainer = styled.div`
    width: 150px;
    border-radius: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    margin: 10px 0px;

`

export const Icon = styled.div`
    width: 60px;
    height: 60px;
    border-radius: 50%;
    background-color: var(--medGrey);
    color: var(--secondary);
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 10px;
    transition: all 0.5s ease;
    cursor: pointer;

    &:hover{
        color: var(--primary);
        transform: scale(1.1);
    }
`